/**
 * The registration password policy, for the SHER-803 accept screen on develop-skincair.
 *
 * Same module name and shape as `develop`'s (SHER-753), so the accept screen crosses between the
 * lines unchanged. The VALUES are this line's: at least 6 characters, as enforced today by the
 * `strongPassword` case in utils/index.jsx and shown by components/general/password_requirements.jsx
 * (develop moved to 8). Those two still carry their own copies on this line; folding them onto this
 * module is SHER-753's change and is not made here.
 */
export const PASSWORD_RULES = [
    { key: "length", translationId: "register.common.password.rules.length", test: (v) => v.length >= 6 },
    { key: "uppercase", translationId: "register.common.password.rules.uppercase", test: (v) => /[A-Z]/.test(v) },
    { key: "number", translationId: "register.common.password.rules.number", test: (v) => /[0-9]/.test(v) },
    { key: "special", translationId: "register.common.password.rules.special", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const meetsPasswordPolicy = (password) => PASSWORD_RULES.every((rule) => rule.test(password || ""));
